import React from 'react';
// import PropTypes from 'prop-types';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
// import MerchantTransaction from './MerchantTransaction';
// import MerchantDashboard from './MerchantDashboard';
import MerchantProfile from './MerchantProfile';

function MerchantRoutes() {
  const match = useRouteMatch();
  return (
    <Switch>
      {/* <Route path={`${match.path}/dashboard`} component={MerchantDashboard} />
      <Route
        path={`${match.path}/transactions`}
        component={MerchantTransaction}
      /> */}
      <Route path={`${match.path}/profile`} component={MerchantProfile} />
      {/* <Redirect to={`${match.url}/profile`} /> */}
    </Switch>
  );
}

MerchantRoutes.propTypes = {};

export default MerchantRoutes;
